<script lang="js" setup>
import Icon1 from '@/assets/images/referral/ic-how-1.svg?url'
import Icon2 from '@/assets/images/referral/ic-how-2.svg?url'
import Icon3 from '@/assets/images/referral/ic-how-3.svg?url'

const { t } = useI18n()

const list = computed(() => [
  {
    title: t('发送邀请给好友'),
    desc: t('通过分享链接邀请好友注册 TT'),
    icon: Icon1,
  },
  {
    title: t('好友注册'),
    desc: t('好友接受邀请完成注册并进行交易'),
    icon: Icon2,
  },
  {
    title: t('获得相应比例返佣'),
    desc: t('轻松获得交易手续费返佣福利'),
    icon: Icon3,
  },
])
</script>

<template>
  <div class="flex justify-center py-10">
    <div v-for="(i, index) in list" :key="index" class="w-1/3">
      <img :src="i.icon" class="w-10 h-10">
      <div class="font-bold text-lg mt-4">
        {{ i.title }}
      </div>
      <div class="text-sm text-textSecondary mt-1">
        {{ i.desc }}
      </div>
    </div>
  </div>
</template>
